import { slideToggle } from './slide-toggle';

document.addEventListener('DOMContentLoaded', () => {
    setupMobileMenu();
    // setupDesktopMenu();
});

function setupMobileMenuz() {
    // Handle clicks outside of the sidebar menu - to close it
    document.addEventListener('click', e => {
        const openMenus = document.querySelectorAll('.sidebar-menu .sidebar.open');
        if (!openMenus.length) {
            return;
        }

        e.preventDefault();
        openMenus.forEach(menuSidebarElement => {
            menuSidebarElement.parentElement.querySelector('.toggle.open').classList.remove('open');
            menuSidebarElement.classList.remove('open');
        });
    });

    // Prevent clicks inside the sidebar menu from closing it (see handler above)
    document.querySelectorAll('.sidebar-menu').forEach(sidebarMenuElement =>
        sidebarMenuElement.addEventListener('click', e => {
            e.stopPropagation();
        })
    );

    // Toggle the related sidebar menu
    document.querySelectorAll('.sidebar-menu .toggle').forEach(toggleElement =>
        toggleElement.addEventListener('click', e => {
            e.stopPropagation();
            toggleElement.classList.toggle('open');
            toggleElement.parentElement.querySelector('.sidebar').classList.toggle('open');
        })
    );

    // Toggle submenu
    document.querySelectorAll('.sidebar-menu .menu > li.menu-item-has-children > a').forEach(linkElement => {
        let arrowElement = document.createElement('i');
        arrowElement.classList = 'fa-regular fa-circle-arrow-down arrow';
        arrowElement.addEventListener('click', e => slideToggle(e.target.parentElement.querySelector('.sub-menu'), 300));

        linkElement.after(arrowElement);
    });
    document.querySelectorAll('.sidebar-menu .sub-menu li.menu-item-has-children > a').forEach(linkElement => {
        let arrowElement = document.createElement('i');
        arrowElement.classList = 'fa-solid fa-caret-down arrow';
        arrowElement.addEventListener('click', e => slideToggle(e.target.parentElement.querySelector('.sub-menu'), 300));

        linkElement.after(arrowElement);
    });

    // Hide submenu on load
    document.querySelectorAll('.sidebar-menu .sub-menu').forEach(subMenuElement =>
        subMenuElement.style.display = 'none'
    );
}

// function setupDesktopMenu() {
//     document.querySelectorAll('#navigation-desktop .menu li.menu-item-has-children').forEach(itemElement =>
//         itemElement.addEventListener('mouseover', e =>
//             e.target.classList.toggle('open-sub')
//         )
//     );
// }


function setupMobileMenu() {
    // Slide toggle animation function
    function slideToggle(element, duration) {
        if (window.getComputedStyle(element).display === 'none') {
            return slideDown(element, duration);
        } else {
            return slideUp(element, duration);
        }
    }

    // Slide down animation with parent height adjustment
    function slideDown(element, duration) {
        element.style.removeProperty('display');
        const height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.transitionProperty = 'height';
        element.style.transitionDuration = `${duration}ms`;
        element.offsetHeight; // Force reflow
        element.style.height = height + 'px';

        // Adjust parent submenu height if exists
        const parentSubmenu = element.closest('.sub-menu');
        if (parentSubmenu) {
            const totalHeight = parentSubmenu.scrollHeight + height;
            parentSubmenu.style.height = totalHeight + 'px';
        }

        return new Promise(resolve => {
            setTimeout(() => {
                element.style.removeProperty('height');
                element.style.removeProperty('overflow');
                element.style.removeProperty('transition-duration');
                element.style.removeProperty('transition-property');
                
                if (parentSubmenu) {
                    parentSubmenu.style.removeProperty('height');
                }
                resolve(element);
            }, duration);
        });
    }

    // Slide up animation with parent height adjustment
    function slideUp(element, duration) {
        const parentSubmenu = element.closest('.sub-menu');
        const elementHeight = element.offsetHeight;
        
        element.style.height = elementHeight + 'px';
        element.style.transitionProperty = 'height';
        element.style.transitionDuration = `${duration}ms`;
        element.offsetHeight; // Force reflow
        element.style.overflow = 'hidden';
        element.style.height = 0;

        // Adjust parent submenu height if exists
        if (parentSubmenu) {
            const currentHeight = parentSubmenu.offsetHeight;
            parentSubmenu.style.height = currentHeight + 'px';
            parentSubmenu.offsetHeight; // Force reflow
            parentSubmenu.style.transitionProperty = 'height';
            parentSubmenu.style.transitionDuration = `${duration}ms`;
            parentSubmenu.style.height = (currentHeight - elementHeight) + 'px';
        }

        return new Promise(resolve => {
            setTimeout(() => {
                element.style.display = 'none';
                element.style.removeProperty('height');
                element.style.removeProperty('overflow');
                element.style.removeProperty('transition-duration');
                element.style.removeProperty('transition-property');
                
                if (parentSubmenu) {
                    parentSubmenu.style.removeProperty('height');
                    parentSubmenu.style.removeProperty('transition-duration');
                    parentSubmenu.style.removeProperty('transition-property');
                }
                resolve(element);
            }, duration);
        });
    }

    // Handle clicks outside of the sidebar menu - to close it
    document.addEventListener('click', e => {
        const openMenus = document.querySelectorAll('.sidebar-menu .sidebar.open');
        if (!openMenus.length) {
            return;
        }

        e.preventDefault();
        openMenus.forEach(menuSidebarElement => {
            menuSidebarElement.parentElement.querySelector('.toggle.open').classList.remove('open');
            menuSidebarElement.classList.remove('open');
        });
    });

    // Prevent clicks inside the sidebar menu from closing it
    document.querySelectorAll('.sidebar-menu').forEach(sidebarMenuElement =>
        sidebarMenuElement.addEventListener('click', e => {
            e.stopPropagation();
        })
    );

    // Toggle the related sidebar menu
    document.querySelectorAll('.sidebar-menu .toggle').forEach(toggleElement =>
        toggleElement.addEventListener('click', e => {
            e.stopPropagation();
            toggleElement.classList.toggle('open');
            toggleElement.parentElement.querySelector('.sidebar').classList.toggle('open');
        })
    );

    // Toggle submenu for first level
    document.querySelectorAll('.sidebar-menu .menu > li.menu-item-has-children > a').forEach(linkElement => {
        let arrowElement = document.createElement('i');
        arrowElement.classList = 'fa-regular fa-circle-arrow-down arrow';
        arrowElement.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            slideToggle(e.target.parentElement.querySelector('.sub-menu'), 300);
        });

        linkElement.after(arrowElement);
    });

    // Toggle submenu for nested levels
    document.querySelectorAll('.sidebar-menu .sub-menu li.menu-item-has-children > a').forEach(linkElement => {
        let arrowElement = document.createElement('i');
        arrowElement.classList = 'fa-solid fa-caret-down arrow';
        arrowElement.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            slideToggle(e.target.parentElement.querySelector('.sub-menu'), 300);
        });

        linkElement.after(arrowElement);
    });

    // Hide submenu on load
    document.querySelectorAll('.sidebar-menu .sub-menu').forEach(subMenuElement =>
        subMenuElement.style.display = 'none'
    );
}